import { useQuery } from '@tanstack/react-query'
import { wishlistApi } from '@/api/wishlist'

/** Manager+ only — real wishlist counts from ProductService, not a fabricated "trending" signal. */
export function useTopWishlisted(limit: number) {
  return useQuery({
    queryKey: ['wishlist', 'top', limit],
    queryFn: () => wishlistApi.topWishlisted(limit),
  })
}
